"use client";

import { useEffect } from "react";
import { Box, LinearProgress } from "@mui/material";

const NOOP = () => {};

export default function TopLoadingProgress({ onShown = NOOP, progress }) {
  const hasProgress = Number.isFinite(progress);

  useEffect(() => {
    onShown();
  }, [onShown]);

  return (
    <Box
      aria-label={hasProgress ? "Setup progress" : "Loading"}
      role="status"
      sx={{
        position: "fixed",
        top: 0,
        right: 0,
        left: 0,
        zIndex: 2147483647,
        pointerEvents: "none"
      }}
    >
      <LinearProgress
        variant={hasProgress ? "determinate" : "indeterminate"}
        value={hasProgress ? Math.max(0, Math.min(progress, 100)) : undefined}
        color="primary"
        sx={{
          height: 2,
          "& .MuiLinearProgress-bar1Indeterminate, & .MuiLinearProgress-bar2Indeterminate": {
            animationDuration: "2.8s"
          }
        }}
      />
    </Box>
  );
}
